import React from 'react';

const Card = ({
  children,
  className = '',
  onClick,
  hover = false,
  padding = 'normal',
  ...props
}) => {
  const paddings = {
    none: '',
    small: 'p-4',
    normal: 'p-5',
    large: 'p-6',
  };

  const classes = `
    bg-white
    rounded-2xl
    shadow-md
    ${paddings[padding]}
    ${hover ? 'hover:shadow-xl hover:-translate-y-1 cursor-pointer transition-all duration-200' : ''}
    ${onClick ? 'cursor-pointer' : ''}
    ${className}
  `;

  if (onClick) {
    return (
      <button
        className={`${classes} text-left w-full touch-manipulation active:scale-[0.98]`}
        onClick={onClick}
        {...props}
      >
        {children}
      </button>
    );
  }

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export default Card;
